/* eslint-disable react/jsx-no-target-blank */
import 'devextreme/dist/css/dx.light.css';
import { ReactNode, useState } from 'react';
import { BiXCircle, BiCheckCircle, BiChevronRight, BiSpreadsheet } from 'react-icons/bi';
import { SiWhatsapp } from 'react-icons/si';
import { format } from 'date-fns';
import { Button } from '../Button/Button';
import { Header } from '../Header/Header';
import { Title } from '../Title/Title';
import { Footer } from '../../pages/Template/Footer';
import * as C from './styles';
import { locale } from 'devextreme/localization';

import { useAuth } from '../../hooks/auth';
import { useNavigate } from 'react-router-dom';
import { InitModal } from '../InitModal';
// import api from '../../services/api';
import { useAppStore } from '../../store';
import { ISubscription } from '../../store/types';
import { toast } from 'react-toastify';

type Props = {
  children: ReactNode;
};

export const Theme = ({ children }: Props) => {
  const subscription = useAppStore((store) => store.subscription);
  const subscriptions = useAppStore((store) => store.subscriptions);
  const setSubscription = useAppStore((store) => store.setSubscription);
  const setStep = useAppStore((store) => store.setStep);
  const config = useAppStore((store) => store.config);
  const clearSubscription = useAppStore((store) => store.clearSubscription);
  const [showSelectCulture, setShowSelectCulture] = useState(false);
  const setCutureType = useAppStore((store) => store.setCultureType);
  const loadHybrids = useAppStore((store) => store.loadHybrids);

  const notAllowedNewSubscription = useAppStore(
    (store) => store.notAllowedNewSubscription
  );

  const { user } = useAuth();
  const [modal, setModal] = useState(false);
  const [showSubscriptionsList, setShowSubscriptionsList] = useState(false);

  const navigate = useNavigate();

  locale(navigator.language);

  async function handleLoadData() {
    if (notAllowedNewSubscription) {
      setModal(true);
      return;
    }
    confirmNewSubscription();
  }

  async function confirmContinue() {
    const openSubscriptions = subscriptions.filter(
      (sub: ISubscription) => sub.status === 'OPEN'
    );

    if (openSubscriptions.length === 0) {
      toast.error('Não há inscrições abertas');
      setModal(false);
      return;
    }

    if (openSubscriptions.length === 1) {
      // Se houver apenas uma inscrição, continua diretamente
      const sub = openSubscriptions[0];
      setSubscription(sub);
      await loadHybrids(sub.culture_type);
      setModal(false);
      navigate(`/passo${sub.current_step + 1}`);
    } else {
      // Se houver múltiplas inscrições, mostra a lista
      setModal(false);
      setShowSubscriptionsList(true);
    }
  }

  async function handleSelectSubscription(selectedSub: ISubscription) {
    setSubscription(selectedSub);
    await loadHybrids(selectedSub.culture_type);
    setShowSubscriptionsList(false);
    navigate(`/passo${selectedSub.current_step + 1}`);
  }

  async function handleSelectCulture() {
    if (!subscription.culture_type) {
      return toast.error('Selecione uma cultura para continuar');
    }
    await loadHybrids(subscription.culture_type);
    setShowSelectCulture(false);
    setStep(1);
    navigate('/passo2');
  }

  function CloseModalSelectCulture() {
    setCutureType('');
    setShowSelectCulture(false);
  }
  async function confirmNewSubscription() {
    clearSubscription();
    localStorage.removeItem('@GetapAPP:subscription_id');
    setModal(false);
    if (config.configSub && config.configSorgoSub) {
      setShowSelectCulture(true);
    } else {
      setCutureType(config.configSub ? 'MILHO' : 'SORGO');
      await loadHybrids(config.configSub ? 'MILHO' : 'SORGO');
      setStep(1);
      navigate('/passo2');
    }
  }

  return (
    <C.Container>
      {modal && (
        <InitModal
          titleHeader='Atenção!'
          title='Inscrição iniciada'
          desc='Você tem uma incrição incompleta, deseja continuar ou iniciar uma nova?'
          onClose={() => {
            setModal(false);
          }}
          mxheight='10vh'
        >
          <div className='content-button content-button-init-modal'>
            <Button
              color='#2758ae'
              title='CONTINUAR'
              onClick={confirmContinue}
              iconRight={<BiChevronRight fontSize={22} />}
            />
            <Button
              color='#27AE60'
              title={`NOVA INSCRIÇÃO ${!!subscription.culture_type
                ? `DE ${subscription.culture_type}`
                : ''
                }`}
              onClick={confirmNewSubscription}
              iconRight={<BiChevronRight fontSize={22} />}
            />
          </div>
        </InitModal>
      )}

      {showSelectCulture && (
        <InitModal
          titleHeader='Atenção!'
          title='Seleção de cultura'
          desc='Selecione a cultura desejada e clique em continuar?'
          onClose={CloseModalSelectCulture}
          mxheight='60vh'
          height='320'
        >
          <C.RowSelectButton>
            <C.SelectButton
              isSelect={subscription.culture_type === 'MILHO'}
              onClick={() => {
                setCutureType('MILHO');
              }}
              tl
              bl
            >
              <span>MILHO</span>
            </C.SelectButton>
            <C.SelectButton
              isSelect={subscription.culture_type === 'SORGO'}
              onClick={() => {
                setCutureType('SORGO');
              }}
              tr
              br
            >
              <span>SORGO</span>
            </C.SelectButton>
          </C.RowSelectButton>
          <C.Row>
            <Button
              color='#2758ae'
              title='CANCELAR'
              onClick={CloseModalSelectCulture}
              iconRight={<BiChevronRight fontSize={22} />}
            />
            <Button
              color='#27AE60'
              title={`CONTINUAR ${!!subscription.culture_type
                ? `COM ${subscription.culture_type}`
                : ''
                }`}
              onClick={handleSelectCulture}
              iconRight={<BiChevronRight fontSize={22} />}
            />
          </C.Row>
        </InitModal>
      )}

      {showSubscriptionsList && (
        <InitModal
          titleHeader='Selecione a inscrição'
          title='Inscrições abertas'
          desc='Escolha qual inscrição deseja continuar:'
          onClose={() => {
            setShowSubscriptionsList(false);
          }}
          mxheight='70vh'
        >
          <C.SubscriptionsList>
            {subscriptions
              .filter((sub: ISubscription) => sub.status === 'OPEN')
              .map((sub: ISubscription) => (
                <C.SubscriptionItem
                  key={sub.id}
                  onClick={() => handleSelectSubscription(sub)}
                >
                  <C.SubscriptionInfo>
                    <C.SubscriptionRow>
                      <C.SubscriptionLabel>Código:</C.SubscriptionLabel>
                      <C.SubscriptionValue>{sub.cod}</C.SubscriptionValue>
                    </C.SubscriptionRow>
                    <C.SubscriptionRow>
                      <C.SubscriptionLabel>Data:</C.SubscriptionLabel>
                      <C.SubscriptionValue>
                        {sub.created_at
                          ? format(new Date(sub.created_at), 'dd/MM/yyyy')
                          : '-'}
                      </C.SubscriptionValue>
                    </C.SubscriptionRow>
                    <C.SubscriptionRow>
                      <C.SubscriptionLabel>Fazenda:</C.SubscriptionLabel>
                      <C.SubscriptionValue>
                        {sub.property?.name || '-'}
                      </C.SubscriptionValue>
                    </C.SubscriptionRow>
                    <C.SubscriptionRow>
                      <C.SubscriptionLabel>Safra:</C.SubscriptionLabel>
                      <C.SubscriptionValue>{sub.haverst || '-'}</C.SubscriptionValue>
                    </C.SubscriptionRow>
                  </C.SubscriptionInfo>
                  <C.SubscriptionArrow>
                    <BiChevronRight fontSize={20} />
                  </C.SubscriptionArrow>
                </C.SubscriptionItem>
              ))}
          </C.SubscriptionsList>
        </InitModal>
      )}

      <Header />

      <C.Area>
        <C.Steps>
          <C.Sidebar>
            <C.ContentLeft>
              <Title title='Inscrição' />
              {user && subscription.current_step === 0 && (
                <Button
                  color={
                    config.configSub || config.configSorgoSub
                      ? '#27AE60'
                      : '#ec7a7a'
                  }
                  title={
                    config.configSub || config.configSorgoSub
                      ? 'NOVA INSCRIÇÃO'
                      : 'INCRIÇŌES ENCERRADAS'
                  }
                  onClick={
                    config.configSub || config.configSorgoSub
                      ? handleLoadData
                      : () => { }
                  }
                  iconRight={<BiChevronRight fontSize={22} />}
                />
              )}
              <br />
              {user && subscription.current_step === 0 && (
                <Button
                  onClick={() => navigate("/dados-inscricao")}
                  title="Verificar inscrição"
                  color="#27AE60"
                  iconRight={<BiSpreadsheet fontSize={22} />}
                />
              )}

              {user && subscription.current_step > 0 && (
                <C.CheckSteps>
                  <C.ContentStep
                    color={subscription.current_step >= 1 ? '1' : '0'}
                  >
                    {subscription.current_step >= 1 ? (
                      <BiCheckCircle
                        fontSize={20}
                        style={{ marginRight: 10 }}
                      />
                    ) : (
                      <BiXCircle fontSize={20} style={{ marginRight: 10 }} />
                    )}{' '}
                    Dados pessoais e da propriedade
                  </C.ContentStep>
                  <C.ContentStep
                    color={subscription.current_step >= 4 ? '1' : '0'}
                  >
                    {subscription.current_step >= 4 ? (
                      <BiCheckCircle
                        fontSize={20}
                        style={{ marginRight: 10 }}
                      />
                    ) : (
                      <BiXCircle fontSize={20} style={{ marginRight: 10 }} />
                    )}{' '}
                    Aceite do regulamento
                  </C.ContentStep>
                  <C.ContentStep
                    color={subscription.current_step >= 5 ? '1' : '0'}
                  >
                    {subscription.current_step >= 5 ? (
                      <BiCheckCircle
                        fontSize={20}
                        style={{ marginRight: 10 }}
                      />
                    ) : (
                      <BiXCircle fontSize={20} style={{ marginRight: 10 }} />
                    )}{' '}
                    Pagamento
                  </C.ContentStep>
                  <C.ContentStep
                    color={subscription.current_step >= 10 ? '1' : '0'}
                  >
                    {subscription.current_step >= 10 ? (
                      <BiCheckCircle
                        fontSize={20}
                        style={{ marginRight: 10 }}
                      />
                    ) : (
                      <BiXCircle fontSize={20} style={{ marginRight: 10 }} />
                    )}{' '}
                    Informações da área inscrita
                  </C.ContentStep>
                  <C.ContentStep
                    color={subscription.current_step >= 12 ? '1' : '0'}
                  >
                    {subscription.current_step >= 12 ? (
                      <BiCheckCircle
                        fontSize={20}
                        style={{ marginRight: 10 }}
                      />
                    ) : (
                      <BiXCircle fontSize={20} style={{ marginRight: 10 }} />
                    )}{' '}
                    Agendamento de auditoria
                  </C.ContentStep>
                </C.CheckSteps>
              )}
            </C.ContentLeft>
          </C.Sidebar>
          <C.Page>{children}</C.Page>
        </C.Steps>
      </C.Area>
      <Footer />
      <C.WhatsApp>
        <a
          href='https://api.whatsapp.com/send/?phone=%2B5534991941413&text=Ol%C3%A1%2C+gostaria+de+atendimento+por+favor%21&type=phone_number&app_absent=0'
          target={'_blank'}
          rel="noopener noreferrer"
        >
          <SiWhatsapp />
        </a>
      </C.WhatsApp>


    </C.Container>
  );
};
